import { Capacitor, CapacitorHttp } from "@capacitor/core";
import { XMLParser } from "fast-xml-parser";
import { getApiBase } from "../../utilis/config";

const base = await getApiBase();

const RestroOrderService = {
  listItem: async () => {
    try {
      let rawText;
      const API_PATH = "/Modules/ROI_Item/RoiItem.asmx/GetItemList";
      const apiUrl = `${base}${API_PATH}`;
      if (Capacitor.getPlatform() !== "web") {
        // Native → CapacitorHttp bypasses CORS
        const response = await CapacitorHttp.post({
          url: apiUrl,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: "", // empty string for .asmx POST
        });

        // Ensure rawText is a string (CapacitorHttp may parse automatically)
        rawText =
          typeof response.data === "string"
            ? response.data
            : JSON.stringify(response.data);
      } else {
        // Web → fetch
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: "", // empty string for .asmx POST
        });

        rawText = await response.text();
      }

      // Parse XML to extract JSON string
      const parser = new XMLParser();
      const parsedXml = parser.parse(rawText);
      const innerText = parsedXml?.string || "";

      // Convert JSON string to JS object/array
      const jsonData = JSON.parse(innerText);

      return jsonData;
    } catch (error) {
      console.error("Error in listItem:", error);
      throw error;
    }
  },

  listCategory: async (languageid = "1") => {
    try {
      const params = new URLSearchParams();
      params.append("languageid", languageid);

      const API_PATH = "/Services/OrderWebservice.asmx/getGlobalizedMenu";

      const apiUrl = `${base}${API_PATH}`;
      let rawText;

      if (Capacitor.getPlatform() !== "web") {
        // Native → CapacitorHttp bypasses CORS
        const response = await CapacitorHttp.post({
          url: apiUrl,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: params.toString(),
        });
        console.log("🚀 ~ response:", response);

        // CapacitorHttp returns parsed JSON if possible, but here it's XML string
        rawText =
          typeof response.data === "string"
            ? response.data
            : JSON.stringify(response.data);
        console.log("🚀 ~ rawText:", rawText);
      } else {
        // Web → fetch
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: params.toString(),
        });
        console.log("🚀 ~ response:", response);

        rawText = await response.text();
        console.log("🚀 ~ rawText:", rawText);
      }

      // Parse XML to extract JSON string
      const parser = new XMLParser();
      const parsedXml = parser.parse(rawText);
      const innerText = parsedXml?.string || "";

      // Convert JSON string to JS object/array
      const jsonData = JSON.parse(innerText);

      return jsonData;
    } catch (error) {
      console.error("Error in listCategory:", error);
      throw error;
    }
  },

  getSection: async () => {
    try {
      // const API_PATH =
      //   "/Modules/RestroDashboard/services/DashBoardWebService.asmx/getTable";
      const API_PATH = "/Modules/RORoom/RORoomWebService.asmx/GetRooms";
      const apiUrl = `${base}${API_PATH}`;

      let rawText;

      if (Capacitor.getPlatform() !== "web") {
        // Native → CapacitorHttp bypasses CORS
        const response = await CapacitorHttp.post({
          url: apiUrl,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: "", // empty string for .asmx POST
        });
        console.log("🚀 ~ response:", response);

        // Ensure rawText is string
        rawText =
          typeof response.data === "string"
            ? response.data
            : JSON.stringify(response.data);
        console.log("🚀 ~ rawText:", rawText);
      } else {
        // Web → fetch
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: "", // empty string for .asmx POST
        });

        rawText = await response.text();
      }

      // Parse XML to extract JSON string
      const parser = new XMLParser();
      const parsedXml = parser.parse(rawText);
      const innerText = parsedXml?.string || "";

      // Convert JSON string to JS object/array
      const jsonData = JSON.parse(innerText);

      return jsonData;
    } catch (error) {
      console.error("Error in getTable:", error);
      throw error;
    }
  },
  getTable: async ({ RoomId }) => {
    try {
      const API_PATH =
        "/Modules/RestroDashboard/services/DashBoardWebService.asmx/GetTableByRoomTypeIdWeb";

      const apiUrl = `${base}${API_PATH}`;

      let rawText;

      const encodedBody = `RoomId=${RoomId}`; // <--- IMPORTANT FIX

      if (Capacitor.getPlatform() !== "web") {
        // Native → CapacitorHttp bypasses CORS
        const response = await CapacitorHttp.post({
          url: apiUrl,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: encodedBody, // <--- ASMX needs urlencoded text, NOT object
        });

        rawText =
          typeof response.data === "string"
            ? response.data
            : JSON.stringify(response.data);
      } else {
        // Web → fetch
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: encodedBody, // <--- SAME HERE
        });

        rawText = await response.text();
      }

      // Parse XML inside SOAP-like response
      const parser = new XMLParser();
      const parsedXml = parser.parse(rawText);
      const innerText = parsedXml?.string || "";

      const jsonData = JSON.parse(innerText);

      return jsonData;
    } catch (error) {
      console.error("Error in getTable:", error);
      throw error;
    }
  },

  orderById: async ({ tableId }) => {
    try {
      const params = new URLSearchParams();
      params.append("tableId", String(tableId));
      const API_PATH =
        "/Modules/RestroDashboard/services/DashBoardWebService.asmx/GettabledataByIdforMenu";
      const apiUrl = `${base}${API_PATH}`;
      let rawText;

      if (Capacitor.getPlatform() !== "web") {
        // Native → CapacitorHttp bypasses CORS
        const response = await CapacitorHttp.post({
          url: apiUrl,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: params.toString(),
        });
        console.log("🚀 ~ response:", response);

        rawText =
          typeof response.data === "string"
            ? response.data
            : JSON.stringify(response.data);
        console.log("🚀 ~ rawText:", rawText);
      } else {
        // Web → fetch
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: params.toString(),
        });

        rawText = await response.text();
      }

      // Parse XML to extract JSON string
      const parser = new XMLParser();
      const parsedXml = parser.parse(rawText);
      const innerText = parsedXml?.string || "";

      // Convert JSON string to JS object/array
      const jsonData = innerText ? JSON.parse(innerText) : [];

      return jsonData;
    } catch (error) {
      console.error("Error in orderById:", error);
      throw error;
    }
  },

  order: async (data) => {
    try {
      const API_PATH = "/Services/OrderWebservice.asmx/SaveOrderIntoDataBase";
      const apiUrl = `${base}${API_PATH}`;
      let responseData;

      if (Capacitor.getPlatform() !== "web") {
        // Native → CapacitorHttp bypasses CORS
        const response = await CapacitorHttp.post({
          url: apiUrl,
          headers: { "Content-Type": "application/json" }, // JSON for backend
          data,
        });
        console.log("🚀 ~ response:", response);

        // CapacitorHttp automatically parses JSON responses
        responseData = response.data;
        console.log("🚀 ~ responseData:", responseData);
      } else {
        // Web → fetch
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });

        responseData = await response.json();
      }

      return responseData;
    } catch (error) {
      console.error("Error in order API:", error);
      throw error;
    }
  },

  shiftTable: async ({
    fromOrderMasterId,
    toTableId,
    fromSeatNo,
    toSeatNo,
    shiftedBy,
    fromTableTitle,
    toTableTitle,
    orderNo,
  }) => {
    try {
      const base = await getApiBase();
      const fullUrl = `${base}/Modules/RestroDashboard/services/DashBoardWebService.asmx/shiftTable`;

      const payload = {
        fromordermasterid: String(fromOrderMasterId),
        totableID: String(toTableId),
        fromSeatNo: String(fromSeatNo),
        toSeatNo: String(toSeatNo),
        shiftedby: String(shiftedBy),
        fromTableTitle: String(fromTableTitle),
        toTableTitle: String(toTableTitle),
        OrderNo: String(orderNo),
      };

      let rawText;

      if (Capacitor.getPlatform() !== "web") {
        // ✅ Native APK — use CapacitorHttp (no CORS)
        const response = await CapacitorHttp.post({
          url: fullUrl,
          headers: { "Content-Type": "application/json" },
          data: payload,
        });

        rawText =
          typeof response.data === "string"
            ? response.data
            : JSON.stringify(response.data);
      } else {
        // ✅ Web — use fetch
        const response = await fetch(fullUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        rawText = await response.text();
      }

      // Parse XML → JSON if backend returns XML-wrapped <string> JSON
      const parser = new XMLParser();
      const parsed = parser.parse(rawText);
      const inner = parsed?.string || rawText;

      return JSON.parse(inner);
    } catch (error) {
      console.error("Error in shiftTable:", error);
      throw error;
    }
  },

  /**
   * Shift specific items between tables
   */
  shiftItem: async ({
    orderMasterId,
    orderNo,
    fromTable,
    fromTableTitle,
    toTable,
    toTableTitle,
    fromSplitNo,
    toSplitNo,
    shiftedBy,
    itemList,
    shiftType = "Regular",
  }) => {
    try {
      const base = await getApiBase();
      const fullUrl = `${base}/Services/RestroWebService.asmx/shiftItemsWeb`;

      const payload = {
        shiftItems: {
          shiftType,
          OrderMasterID: String(orderMasterId),
          OrderNo: String(orderNo),
          fromTable: String(fromTable),
          fromTableTitle,
          toTable: String(toTable),
          toTableTitle,
          fromSplitNo: String(fromSplitNo),
          toSplitNo: String(toSplitNo),
          shiftedBy,
          itemList,
        },
      };

      let rawText;

      if (Capacitor.getPlatform() !== "web") {
        // ✅ Native (CapacitorHttp)
        const response = await CapacitorHttp.post({
          url: fullUrl,
          headers: { "Content-Type": "application/json" },
          data: payload,
        });
        rawText =
          typeof response.data === "string"
            ? response.data
            : JSON.stringify(response.data);
      } else {
        // ✅ Web
        const response = await fetch(fullUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        rawText = await response.text();
      }

      const parser = new XMLParser();
      const parsed = parser.parse(rawText);
      const inner = parsed?.string || rawText;

      return JSON.parse(inner);
    } catch (error) {
      console.error("Error in shiftItem:", error);
      throw error;
    }
  },

  cancelOrderByItems: async ({ canceledItems }) => {
    try {
      const API_PATH = "/Services/OrderWebService.asmx/SaveCanceledItems";
      const apiUrl = `${base}${API_PATH}`;

      // JSON payload
      const payload = { CancelItems: canceledItems };

      let responseData;

      if (Capacitor.getPlatform() !== "web") {
        // Native (Capacitor)
        const resp = await CapacitorHttp.post({
          url: apiUrl,
          headers: { "Content-Type": "application/json" },
          data: payload,
        });

        responseData =
          typeof resp.data === "string" ? JSON.parse(resp.data) : resp.data;
      } else {
        // Web (browser)
        const resp = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!resp.ok) {
          const txt = await resp.text();
          throw new Error(`HTTP ${resp.status} – ${txt}`);
        }

        responseData = await resp.json();
      }

      return { success: true, data: responseData };
    } catch (error) {
      console.error("cancelOrderByItems error →", error);
      throw error;
    }
  },

  getFoodCourt: async () => {
    try {
      const API_PATH = "/Services/OrderWebservice.asmx/GetOrderTableKeys";
      const apiUrl = `${base}${API_PATH}`;
      let rawText;

      if (Capacitor.getPlatform() !== "web") {
        // Native → CapacitorHttp
        const response = await CapacitorHttp.post({
          url: apiUrl,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: "",
        });

        rawText =
          typeof response.data === "string"
            ? response.data
            : JSON.stringify(response.data);
      } else {
        // Web fetch
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: "",
        });

        rawText = await response.text();
      }

      // Parse XML
      const parser = new XMLParser({ ignoreAttributes: false });
      const parsedXml = parser.parse(rawText);

      // Extract orders
      const items =
        parsedXml?.ArrayOfOrderTableKeyInfo?.OrderTableKeyInfo || [];

      // Normalize TableKey to string
      const normalized = items.map((o) => ({
        ...o,
        TableKey: String(o.TableKey).trim().toUpperCase(),
      }));

      return normalized; // <-- returns array of objects
    } catch (error) {
      console.error("Error in getFoodCourt:", error);
      throw error;
    }
  },

  getPreviousOrder: async ({ tableKey }) => {
    try {
      const params = new URLSearchParams();
      params.append("tableKey", String(tableKey));
      const API_PATH = "/Services/OrderWebservice.asmx/GetPreviousOrder";
      const apiUrl = `${base}${API_PATH}`;
      let rawText;

      if (Capacitor.getPlatform() !== "web") {
        // Native → CapacitorHttp bypasses CORS
        const response = await CapacitorHttp.post({
          url: apiUrl,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: params.toString(),
        });
        console.log("🚀 ~ response:", response);

        rawText =
          typeof response.data === "string"
            ? response.data
            : JSON.stringify(response.data);
        console.log("🚀 ~ rawText:", rawText);
      } else {
        // Web → fetch
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: params.toString(),
        });

        rawText = await response.text();
      }

      // Parse XML to extract JSON string
      const parser = new XMLParser();
      const parsedXml = parser.parse(rawText);
      const innerText = parsedXml?.string || "";

      // Convert JSON string to JS object/array
      const jsonData = innerText ? JSON.parse(innerText) : [];

      return jsonData;
    } catch (error) {
      console.error("Error in orderById:", error);
      throw error;
    }
  },

  shiftFoodCourt: async ({ username, orderMasterID, newTableKey }) => {
    try {
      const base = await getApiBase();
      const fullUrl = `${base}/Services/OrderWebservice.asmx/ShiftTableSave`;

      const payload = {
        username: username,
        newTableKey: newTableKey,
        orderMasterID: orderMasterID,
      };

      let rawText;

      if (Capacitor.getPlatform() !== "web") {
        // ✅ Native APK — use CapacitorHttp (no CORS)
        const response = await CapacitorHttp.post({
          url: fullUrl,
          headers: { "Content-Type": "application/json" },
          data: payload,
        });

        rawText =
          typeof response.data === "string"
            ? response.data
            : JSON.stringify(response.data);
      } else {
        // ✅ Web — use fetch
        const response = await fetch(fullUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        rawText = await response.text();
      }

      // Parse XML → JSON if backend returns XML-wrapped <string> JSON
      const parser = new XMLParser();
      const parsed = parser.parse(rawText);
      const inner = parsed?.string || rawText;

      return JSON.parse(inner);
    } catch (error) {
      console.error("Error in shiftTable:", error);
      throw error;
    }
  },

  mergeCourt: async ({ username, orderMasterID, tableData }) => {
    try {
      const base = await getApiBase();
      const fullUrl = `${base}/Services/OrderWebservice.asmx/SaveMergeTable`;

      const payload = {
        username: username,

        orderMasterID: orderMasterID,
        tableData: tableData,
      };

      let rawText;

      if (Capacitor.getPlatform() !== "web") {
        // ✅ Native APK — use CapacitorHttp (no CORS)
        const response = await CapacitorHttp.post({
          url: fullUrl,
          headers: { "Content-Type": "application/json" },
          data: payload,
        });

        rawText =
          typeof response.data === "string"
            ? response.data
            : JSON.stringify(response.data);
      } else {
        // ✅ Web — use fetch
        const response = await fetch(fullUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        rawText = await response.text();
      }

      // Parse XML → JSON if backend returns XML-wrapped <string> JSON
      const parser = new XMLParser();
      const parsed = parser.parse(rawText);
      const inner = parsed?.string || rawText;

      return JSON.parse(inner);
    } catch (error) {
      console.error("Error in shiftTable:", error);
      throw error;
    }
  },

  getCustomerList: async () => {
    try {
      const API_PATH = "/Services/OrderWebservice.asmx/GetCustomerDatas";
      const apiUrl = `${base}${API_PATH}`;

      let responseData;

      if (Capacitor.getPlatform() !== "web") {
        const response = await CapacitorHttp.post({
          url: apiUrl,
          headers: { "Content-Type": "application/json" },
          data: { customer: 1 },
        });

        responseData =
          typeof response.data === "string"
            ? JSON.parse(response.data)
            : response.data;
      } else {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ customer: 1 }),
        });

        const text = await response.text();
        responseData = JSON.parse(text);
      }

      // The actual array is inside responseData.d
      const jsonData = responseData?.d ? JSON.parse(responseData.d) : [];
      console.log("🚀 ~ jsonData:", jsonData);

      return jsonData;
    } catch (error) {
      console.error("Error in getCustomerList:", error);
      throw error;
    }
  },


  extraListItem: async () => {
    try {
      let rawText;
      const API_PATH = "/Services/OrderWebservice.asmx/GetExtraItemsByItem";
      const apiUrl = `${base}${API_PATH}`;
      if (Capacitor.getPlatform() !== "web") {
        // Native → CapacitorHttp bypasses CORS
        const response = await CapacitorHttp.post({
          url: apiUrl,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: "", // empty string for .asmx POST
        });

        // Ensure rawText is a string (CapacitorHttp may parse automatically)
        rawText =
          typeof response.data === "string"
            ? response.data
            : JSON.stringify(response.data);
      } else {
        // Web → fetch
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: "", // empty string for .asmx POST
        });

        rawText = await response.text();
      }

      // Parse XML to extract JSON string
      const parser = new XMLParser();
      const parsedXml = parser.parse(rawText);
      const innerText = parsedXml?.string || "";

      // Convert JSON string to JS object/array
      const jsonData = JSON.parse(innerText);

      return jsonData;
    } catch (error) {
      console.error("Error in listItem:", error);
      throw error;
    }
  },
};

export default RestroOrderService;
